var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExternal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6362 1.92256C11.8698 1.82582 12.1386 1.8793 12.3173 2.05805L18.5673 8.30805C18.8114 8.55212 18.8114 8.94785 18.5673 9.19193L12.3173 15.4419C12.1386 15.6207 11.8698 15.6742 11.6362 15.5774C11.4027 15.4807 11.2504 15.2528 11.2504 15V11.8925C7.0402 12.1282 4.05747 14.6916 2.875 15.9501C2.74164 16.0948 2.56606 16.1939 2.37313 16.2333C2.17811 16.2732 1.97547 16.2499 1.79456 16.1669C1.61364 16.0839 1.46385 15.9454 1.36686 15.7716C1.27026 15.5985 1.23104 15.3992 1.25482 15.2024C1.5713 12.4664 3.14449 10.076 5.14426 8.37971C6.95575 6.84314 9.17669 5.82575 11.2504 5.65161V2.49999C11.2504 2.2472 11.4027 2.0193 11.6362 1.92256ZM12.5004 4.00887V6.24999C12.5004 6.59517 12.2206 6.87499 11.8754 6.87499C9.99502 6.87499 7.77994 7.78316 5.95284 9.33296C4.37958 10.6674 3.14772 12.4321 2.66649 14.4011C4.33597 12.8661 7.54727 10.625 11.8754 10.625C12.2206 10.625 12.5004 10.9048 12.5004 11.25V13.4911L17.2415 8.74999L12.5004 4.00887Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExternal);
export default __webpack_public_path__ + "static/media/external.b293c2603d86880c401fb072e9562747.svg";
export { ForwardRef as ReactComponent };